module.exports = __webpack_public_path__ + "static/media/toilet_icon.8a0b27d5.svg";